import {
	ConfluencePageAri,
	CmdbObjectAri,
	JiraIssueAri,
	TownsquareGoalAri,
	TownsquareProjectAri,
	IdentityTeamAri,
} from '@atlassian/ari';
import type { GlobalObjectType } from '@atlassian/preview-panel-global-objects/types';

import { fg } from '@confluence/feature-gating';

import { hasPreviewPanelIndicators, isInIframe } from './utils/previewPanelUtils.ts';

export const ALL_SUPPORTED_OBJECTS: GlobalObjectType[] = [
	'jira-issue',
	'confluence-page',
	'identity-team',
	'townsquare-goal',
	'townsquare-project',
	'cmdb-object',
];

export const isPreviewPanelAvailable = ({ ari }: { ari: string }): boolean => {
	const href = window?.location?.href;

	if (href) {
		const searchParams = new URL(href).searchParams;

		if (searchParams.get('parentProduct')?.toLowerCase() === 'jsm') {
			return false;
		}
		if (isInIframe() && !hasPreviewPanelIndicators(searchParams)) {
			return false;
		}
	}

	if (ConfluencePageAri.check(ari)) {
		return true;
	}
	if (JiraIssueAri.check(ari)) {
		return true;
	}
	if (TownsquareGoalAri.check(ari)) {
		return true;
	}
	if (TownsquareProjectAri.check(ari)) {
		return true;
	}
	if (IdentityTeamAri.check(ari)) {
		return true;
	}
	// eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
	if (CmdbObjectAri.check(ari) && fg('open_preview_panel_for_assets_object_in_confluence')) {
		return true;
	}

	return false;
};
